export default "__VITE_ASSET__abed77b3__"